import React from 'react';

import EditProfileForm from './EditProfileForm.js';
import querySelector from 'selectors/lib/querySelector.js';
import { useSelector } from 'react-redux';
import Slider from '../../components/Slider.js';
import setQuery from '../../lib/setQuery.js';

const ProfileSlider = () => {
  const profileView = useSelector(querySelector('profile_view'));
  const loggedIn = useSelector((state) => state.user.loggedIn);

  const handleSliderHide = () => {
    setQuery({ profile_view: null });
  };

  if (!loggedIn) {
    return null;
  }

  return (
    <Slider classes="profile-slider" show={profileView} onHide={handleSliderHide} className={'profile-view'}>
      {!!profileView && <EditProfileForm />}
    </Slider>
  );
};

export default ProfileSlider;
